import React from 'react';
import {
  FilterBarWrapper, FilterGrid, FilterSelect, FilterToggleGroup, FilterToggle,
  FilterPriceGroup, FilterPriceSep, FilterClearBtn, FilterCount,
  FilterSearchInput, Container,
} from '../styles/MFRealStateStyles';
import { formatPrice } from '../services/propertyService';

const QUARTOS_OPTIONS = [
  { label: 'Quartos', value: '' },
  { label: '1 quarto', value: 1 },
  { label: '2 quartos', value: 2 },
  { label: '3 quartos', value: 3 },
  { label: '4+ quartos', value: 4 },
];

const TIPO_LABELS = {
  apartamento: 'Apartamento',
  casa: 'Casa',
  cobertura: 'Cobertura',
  terreno: 'Terreno',
  sala: 'Sala Comercial',
  studio: 'Studio',
  galpao: 'Galpão',
  garagem: 'Garagem',
};

const FAIXAS_VENDA = [
  500_000, 700_000, 1_000_000, 1_500_000, 2_000_000, 3_000_000,
  5_000_000, 7_000_000, 10_000_000, 15_000_000, 20_000_000,
];

const FAIXAS_ALUGUEL = [
  1_000, 2_000, 3_000, 5_000, 7_000, 10_000, 15_000, 20_000, 30_000, 50_000,
];

function faixasParaExibir(tipoNegocio) {
  return tipoNegocio === 'locacao' ? FAIXAS_ALUGUEL : FAIXAS_VENDA;
}

export default function FilterBar({ filters, setFilters, count, cidades = [], condominiosByCity = {}, tipos = [] }) {
  const set = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value || null }));
  };

  const setCidade = (value) => {
    setFilters(prev => ({
      ...prev,
      cidade: value || null,
      condominio: null,
    }));
  };

  const condominiosDaCidade = filters.cidade ? (condominiosByCity[filters.cidade] || []) : [];

  const setNegocio = (value) => {
    setFilters(prev => ({
      ...prev,
      tipo_negocio: prev.tipo_negocio === value ? null : value,
      preco_min: null,
      preco_max: null,
    }));
  };

  const hasActiveFilters = Object.values(filters).some(v => v != null);

  const clearAll = () => {
    setFilters({
      busca: null,
      tipo_negocio: null,
      tipo: null,
      cidade: null,
      condominio: null,
      quartos_min: null,
      preco_min: null,
      preco_max: null,
    });
  };

  const faixas = faixasParaExibir(filters.tipo_negocio);

  const faixasMin = filters.preco_max
    ? faixas.filter(v => v < filters.preco_max)
    : faixas;

  const faixasMax = filters.preco_min
    ? faixas.filter(v => v > filters.preco_min)
    : faixas;

  return (
    <FilterBarWrapper>
      <Container>
        <FilterGrid>
          {/* Busca */}
          <FilterSearchInput
            type="text"
            placeholder="Buscar por nome, endereço, condomínio..."
            value={filters.busca || ''}
            onChange={e => set('busca', e.target.value)}
          />

          {/* Tipo de negocio */}
          <FilterToggleGroup>
            <FilterToggle
              $active={filters.tipo_negocio === 'venda'}
              onClick={() => setNegocio('venda')}
            >
              Venda
            </FilterToggle>
            <FilterToggle
              $active={filters.tipo_negocio === 'locacao'}
              onClick={() => setNegocio('locacao')}
            >
              Locação
            </FilterToggle>
          </FilterToggleGroup>

          {/* Cidade */}
          <FilterSelect
            value={filters.cidade || ''}
            onChange={e => setCidade(e.target.value)}
          >
            <option value="">Cidade</option>
            {cidades.map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </FilterSelect>

          {/* Condomínio (condicional: só aparece se cidade tiver condomínios) */}
          {filters.cidade && condominiosDaCidade.length > 0 && (
            <FilterSelect
              value={filters.condominio || ''}
              onChange={e => set('condominio', e.target.value)}
            >
              <option value="">Condomínio</option>
              {condominiosDaCidade.map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </FilterSelect>
          )}

          {/* Tipo de imóvel */}
          <FilterSelect
            value={filters.tipo || ''}
            onChange={e => set('tipo', e.target.value)}
          >
            <option value="">Tipo</option>
            {tipos.map(t => (
              <option key={t} value={t}>{TIPO_LABELS[t] || t}</option>
            ))}
          </FilterSelect>

          {/* Quartos */}
          <FilterSelect
            value={filters.quartos_min || ''}
            onChange={e => set('quartos_min', e.target.value ? Number(e.target.value) : null)}
          >
            {QUARTOS_OPTIONS.map(q => (
              <option key={q.value} value={q.value}>{q.label}</option>
            ))}
          </FilterSelect>

          {/* Faixa de valor */}
          <FilterPriceGroup>
            <FilterSelect
              value={filters.preco_min || ''}
              onChange={e => set('preco_min', e.target.value ? Number(e.target.value) : null)}
            >
              <option value="">Valor min</option>
              {faixasMin.map(v => (
                <option key={v} value={v}>{formatPrice(v)}</option>
              ))}
            </FilterSelect>
            <FilterPriceSep>—</FilterPriceSep>
            <FilterSelect
              value={filters.preco_max || ''}
              onChange={e => set('preco_max', e.target.value ? Number(e.target.value) : null)}
            >
              <option value="">Valor max</option>
              {faixasMax.map(v => (
                <option key={v} value={v}>{formatPrice(v)}</option>
              ))}
            </FilterSelect>
          </FilterPriceGroup>

          {/* Limpar + count */}
          {hasActiveFilters && (
            <FilterClearBtn onClick={clearAll}>Limpar</FilterClearBtn>
          )}

          <FilterCount>{count} {count === 1 ? 'imóvel' : 'imóveis'}</FilterCount>
        </FilterGrid>
      </Container>
    </FilterBarWrapper>
  );
}
